/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 } from 'uuid';

import { IslandType } from './enums';
import { RecordData } from '../../helpers-classes';
import { CornerSize, IslandData, IslandDataIn } from './types';

export const islandData = (dataIn: IslandDataIn = null): IslandData => {
	const rd = new RecordData<IslandDataIn>(dataIn);

	const islandType = rd.useNewOrDefault<IslandType>('type', IslandType.Grill);
	// const panels = dataIn?.panels ?? [];
	// const panelTrims = dataIn?.trims ?? [];

	// if (panels.isNew) panelTrims.reset(panels);

	const record: IslandData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		sku: dataIn?.sku || '',
		type: islandType,
		size: dataIn?.size ?? (islandType === IslandType.Corner ? { width: 0, height: 0, depth: { left: 0, right: 0 }} : { width: 0, height: 0, depth: 0 }),
		axis: dataIn?.axis ?? dataIn?.position?.axis ?? null,
		origin: dataIn?.origin ?? null,
		center: dataIn?.center ?? { x: 0, y: 0, z: 0 },
		connections: dataIn?.connections ?? null,
		trims: dataIn?.trims ?? null,
		panels: dataIn?.panels ?? null,
		surround: dataIn?.surround ?? null,
		panelThickness: dataIn?.panelThickness ?? null
	};

	// fixes schema 7, pre-released data
	if (!dataIn?.size && record.panels?.children.length > 0) {
		record.size.width = (record.panels.children[0] as any).size.width;
		record.size.height = (record.panels.children[0] as any).size.height;
		record.size.depth = (record.panels.children[0] as any).size.depth;
		if (record.type === IslandType.Corner) {
			(record.size as CornerSize).depth.left = 26.5;
			(record.size as CornerSize).depth.right = 26.5;
		} else {
			record.size.depth = (record.panels.children[1] as any).size.width + (2 * (record.panels.children[0] as any).size.depth)
		}
		console.log('FIX:islandData:size', record.type, record.size);
	}


	return record;
};
